import type { FrameworkNames } from "../lib/frameworkLabel";

type Props = FrameworkNames;

export const FrameworkIdentity = ({ title, shortIdentifier }: Props) => {
    const identifier = shortIdentifier?.trim();

    return (
        <span className="flex min-w-0 flex-col leading-tight">
            {identifier ? (
                <span className="text-xs font-ant-strong tracking-wide break-words text-primary">{identifier}</span>
            ) : null}
            <span className="break-words whitespace-normal text-color-ant!">{title}</span>
        </span>
    );
};
